import styled from 'styled-components'

export default {
	Content: styled.div`
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		gap: 8px;
		min-height: 50dvh;

		& > p {
			${({theme}) => theme.font['small-medium']};
			color: ${({theme}) => theme.color['grey3']};
		}
	`,
	QRControls: styled.div`
		display: flex;
		align-items: center;
		justify-content: center;
		margin-top: 12px;
		gap: 12px;

		& > .countdown-text {
			${({theme}) => theme.font['small-regular']};
			color: ${({theme}) => theme.color['grey4']};
			margin: 0;
		}
	`,
	RefreshButton: styled.button`
		${({theme}) => theme.font['xtiny-semibold']};
		padding: 6px 12px;
		background-color: ${({theme}) => theme.color['black']};
		color: ${({theme}) => theme.color['white']};
		border: none;
		border-radius: 4px;
		cursor: pointer;
		transition: opacity 0.2s;

		&:hover {
			opacity: 0.8;
		}

		&:active {
			opacity: 0.6;
		}
	`,
}
